import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const esgQualificationStepResponsesFields: FieldInterface[] = [
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'hasNoMore',
    originKey: 'has_no_more',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'version',
    originKey: 'version',
    type: FIELD_TYPES.string,
  },
  {
    key: 'step',
    originKey: 'step',
    type: FIELD_TYPES.object,
    objectType: 'PiQualificationStep',
    objectTypePath: 'src/piSurvey-types',
  },
]

export const esgQualificationStepResponsesRelations: RelationInterface[] = []
